module.exports = __webpack_public_path__ + "img/investor_Solar@2x.79a5643c.png";